import { state } from '@/views/good-manage/good-list/add-good/state';

/*
 * @Author: your name
 * @Date: 2021-05-19 14:54:39
 * @LastEditTime: 2021-06-23 22:04:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \client\src\store\getters.js
 */
const getters = {
  sidebar: state => state.app.sidebar,
  sellerBookingType: state => state.app.sellerBookingType,
  isShowGuide: state => state.app.isShowGuide,
  // 接口url前端 （说明：自邮接口前缀是business，自提前缀是bookingAdmin）
  urlPrefix(state, val) {
    return state.app.sellerBookingType ? 'bookingAdmin' : 'business';
  },
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  sellerId: state => state.user.sellerId,
  sellerServerStoreStatus: state => state.user.sellerServerStoreStatus,
  yyStoreId: state => state.user.yyStoreId,
  name: state => state.user.name,
  accountName: state => state.user.accountName,
  accountType: state => state.user.accountType,
  currencyCfg: state => state.user.remoteCurrencyConfig,
  currencyDisplaySymbol: (state, gettter) => gettter.currencyCfg.displaySymbol,
  currencyDisplayName: (state, gettter) => gettter.currencyCfg.displayName,
  hasAlipay: (state, gettter) =>
    !!state.user.constantInfo.sellerAppletVoList.find(t => t.originType === 2),
  hasAlipayMo: (state, gettter) =>
    !!state.user.constantInfo.sellerAppletVoList.find(t => t.originType === 4),
  hasWeapp: (state, gettter) =>
    !!state.user.constantInfo.sellerAppletVoList.find(t => t.originType === 1),
  hasUnipay: (state, gettter) =>
    !!state.user.constantInfo.sellerAppletVoList.find(t => t.originType === 3),
  sellerType: (state, gettter) => state.user.constantInfo.sellerType,
  sellerTypeNotAgent: (state, gettter) =>
    state.user.constantInfo.sellerType !== CONST.SELLER_TYPE.agent,
  countryId: (state, gettter) => state.user.constantInfo.countryId,
  menuCodeList: (state, gettter) => state.user.menuInfo.map(t => t.code),
  storeMenuCodeList: (state, gettter) =>
    state.user.storeMenuInfo.map(t => t.code),
  supplierMenuInfo: (state, gettter) =>
    state.user.supplierMenuInfo.map(t => t.code),
  channels: (state, getter) => state.user.channels,
  syncStockFlag: (state, getter) => state.user.constantInfo.syncStockFlag,
  // 装修灰度
  sellerDecorateGrayHit: (state, getter) => state.user.sellerDecorateGrayHit,
  // 装修引导
  sellerDecorateForwardInit: (state, getter) =>
    state.user.sellerDecorateForwardInit,
  // 是否有权限看到微信商家券
  wxCouponExhibitFlag: (state, getter) => state.user.wxCouponExhibitFlag,
  isWhiteList: (state) => state.user.isWhiteList
};
export default getters;
